import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

let sedeAttiva = localStorage.getItem('rsa_sede_attiva') || 'tutte';

export function setSedeAttivaHeader(value) {
  sedeAttiva = value || 'tutte';
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('rsa_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (sedeAttiva && sedeAttiva !== 'tutte' && !config.url?.startsWith('/sedi')) {
    config.params = { ...(config.params || {}), sede_id: sedeAttiva };
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('rsa_token');
      localStorage.removeItem('rsa_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
